export type WorkforceProfileInputMode = 'document' | 'guided' | null;

export interface WorkforceProfileResearchLookup {
  personName: string;
  profileUrl: string;
  currentEmployerName: string;
  currentJobTitle: string;
  location: string;
}

export interface WorkforceProfileWizardSetup {
  departmentId: string;
  seniority: string;
  targetProfileId: string;
}

export interface WorkforceProfileWizardState {
  inputMode: WorkforceProfileInputMode;
  setup: WorkforceProfileWizardSetup;
  lookup: WorkforceProfileResearchLookup;
  suggestedFieldKeys: string[];
  researchCompleted: boolean;
}

export type WorkforceProfileGuidedStepId =
  | 'setup'
  | 'research'
  | 'summary'
  | 'responsibilities'
  | 'experience'
  | 'competencies'
  | 'knowledge'
  | 'education'
  | 'languages'
  | 'extras'
  | 'review';

export const GUIDED_WIZARD_STEP_ORDER: WorkforceProfileGuidedStepId[] = [
  'setup',
  'research',
  'summary',
  'responsibilities',
  'experience',
  'competencies',
  'knowledge',
  'education',
  'languages',
  'extras',
  'review',
];
